import { InventoryLevelSchema } from "@redotech/redo-inventory-levels-common/inventory-level";
import { Product2AttributeValueSchema } from "@redotech/redo-product2-common/product2-attribute-types";
import { Product2ImageSchema } from "@redotech/redo-product2-common/product2-types";
import { WarehouseSchema } from "@redotech/redo-warehouse-common/warehouse-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/* InventoryItem */
export type InventoryItem = z.infer<typeof InventoryItemSchema>;

export const InventoryItemSchema = z.object({
  _id: zExt.objectId(),
  variant: zExt.objectId(),
  inventoryLevels: z.array(InventoryLevelSchema),
});

const InventoryItemUpsertSchema_ = InventoryItemSchema.extend({
  _id: zExt.objectId().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export const InventoryItemUpsertSchema: z.ZodType<InventoryItemUpsert> =
  InventoryItemUpsertSchema_;
export type InventoryItemUpsert = z.infer<typeof InventoryItemUpsertSchema_>;

/* CatalogProductSchema */
export const CatalogVariantSchema = z.object({
  _id: zExt.objectId(),
  attributeValues: z.array(Product2AttributeValueSchema),
  images: z.array(Product2ImageSchema),
  lines: z.array(z.object({ variant: zExt.objectId(), quantity: z.number() })),
});

export const CatalogProductSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  description: z.string().optional(),
  externalId: z.string().optional(),
  externalSource: z.string().optional(),
  attributeValues: z.array(Product2AttributeValueSchema),
  images: z.array(Product2ImageSchema),
  team: zExt.objectId(),
  variants: z.array(CatalogVariantSchema),
});

/* InventoryItemWithWarehouse */
export const InventoryLevelWithWarehouseSchema = InventoryLevelSchema.extend({
  warehouse: WarehouseSchema,
});

export type InventoryLevelWithWarehouse = z.infer<
  typeof InventoryLevelWithWarehouseSchema
>;

export const InventoryItemWithWarehouseSchema = InventoryItemSchema.extend({
  inventoryLevels: z.array(InventoryLevelWithWarehouseSchema),
});

export type InventoryItemWithWarehouse = z.infer<
  typeof InventoryItemWithWarehouseSchema
>;

export const ShipmentProductSchema = z.object({
  images: z.array(z.string()).optional().nullable(),
  quantity: z.number(),
  reasons: z.array(z.string()).optional().nullable(),
  price: z.number(),
  option1: z.string().optional().nullable(),
  option2: z.string().optional().nullable(),
  option3: z.string().optional().nullable(),
  variant_title: z.string(),
  product_title: z.string(),
  product_id: z.string().optional(),
  variant_id: z.string().optional(),
  sku: z.string(),
  barcode: z.string().optional().nullable(),
  isFinalSaleReturn: z.boolean().optional().nullable(),
});

export type ShipmentProduct = z.infer<typeof ShipmentProductSchema>;

export interface BarcodeData {
  title: string;
  sku: string;
  price?: string;
  barcode: string;
}
